import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton/index.jsx";
import LdsImage from "../../components/LdsImage/index.jsx";
import reportTemplateImpressionNegative from "../../assets/module-5/report-template-impression-negative.png";
import reportTemplateImpressionPositive from "../../assets/module-5/report-template-impression-positive.png";
import LdsBlockList from "../../components/LdsBlockList/LdsBlockList.jsx";
import { FigureCaption } from "react-bootstrap";
import exampleReport from "../../assets/module-5/example-report.png";
import LdsTile from "../../components/LdsTile/index.jsx";
import References from "../../components/References/index.jsx";

import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_5_0_4 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8 module-content">
        <main className="module-content">
          <section className="mb-5 learning-heading">
            <h1 className="blue text-uppercase b mt-5">5.0.4 Impression</h1>
            <p className="mt-3 mb-0">Estimated time to complete: 3 minutes</p>
          </section>
          <section>
            <LdsBlockList
              items={[
                {
                  title: "Indications for Ordering",
                  bookmarked: false,
                  iconSlug: "pin",
                  active: false,
                },
                {
                  title: "Technique",
                  bookmarked: false,
                  iconSlug: "wrench",
                  active: false,
                },
                {
                  title: "Findings",
                  bookmarked: true,
                  iconSlug: "memo",
                  active: false,
                },
                {
                  title: "Impression",
                  bookmarked: true,
                  iconSlug: "mag",
                },
              ]}
            />
            <div className="content-block callout mb-5 mt-3">
              <LdsImage
                src={reportTemplateImpressionNegative}
                alt="Example of a negative scan report: 'IMPRESSION: The scan is negative, indicating sparse to no neuritic plaques.'"
              />
              <FigureCaption>Example of a Negative Scan Report</FigureCaption>
              <br className="mb-3" />
              <LdsImage
                src={reportTemplateImpressionPositive}
                alt="Example of a positive scan report: 'IMPRESSION: The scan is positive, indicating moderate to frequent amyloid neuritic plaques.'"
              />
              <FigureCaption>Example of a Positive Scan Report</FigureCaption>
            </div>
            <div className="content-block mb-5 mt-3">
              <h2 className="h5 bold">
                4. Impression<sup>1</sup>
              </h2>
              <ul className="pl-0">
                <li>The impression should clearly state the interpretation</li>
                <ul className="pl-0">
                  <li className="bold">
                    Positive scan: “The scan is positive and indicates moderate
                    to frequent Aβ deposition”
                  </li>
                  <li className="bold">
                    Negative scan: “The scan is negative, indicating sparse to
                    no neuritic plaques”
                  </li>
                  <li>
                    Consider alternative statements to “positive” or “negative”:
                    The findings are consistent with the “presence” or “absence”
                    of Aβ deposition
                  </li>
                </ul>
                <li>
                  The impression should not include statements such as “the scan
                  is diagnostic of Alzheimer's disease”
                </li>
                <li>
                  The objective of Amyvid image interpretation is to provide an estimate of the brain beta-amyloid neuritic plaque density, not
                  to make a clinical diagnosis
                </li>
                <li>
                  A positive Amyvid scan does not establish a diagnosis of AD or
                  other cognitive disorder
                </li>
                <li>
                  Commenting on correlation with other available imaging data,
                  specific to the patient, may be helpful to the referring
                  physician
                </li>
                <li>
                  Consider reordering the scan if a technical issue is suspected
                  such as motion, excessive noise, or image blurring
                </li>
              </ul>
            </div>
          </section>
          <LdsTile className="orange-border-tile mt-4 mb-4">
            <p className="bold">
              Refer to challenge cases in the Additional Scans for Review module
              in the Amyvid Online Reader Training site for more practice with
              these types of common challenges
            </p>
          </LdsTile>
          <div className="text-center">
            <LdsButton
              classes="orange-button mt-3"
              onClick={() => window.open(exampleReport, "_blank")}
            >
              Download Example Report
            </LdsButton>
          </div>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-3", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-5", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Minoshima S, Drzezga AE, Barthel H, et al. SNMMI Procedure
                Standard/EANM Practice Guideline for Amyloid PET Imaging of the
                Brain 1.0. <em>J Nucl Med.</em> 2016;57(8):1316-1322.
              </li>

            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_5_0_4;
